import { Dispatch } from 'react';
import { ApplicationAction } from '../Application/types';

export const useDispatch = (dispatch: Dispatch<ApplicationAction>) => {
  const displayError = (message: string) =>
    dispatch({
      type: 'SET_SNACKBAR',
      payload: { message, state: 'error' }
    });

  const displaySuccess = (message: string) =>
    dispatch({
      type: 'SET_SNACKBAR',
      payload: { message, state: 'success' }
    });

  return { displayError, displaySuccess };
};
